import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9672273c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ttn-view-manager" }
const _hoisted_2 = { class: "ttn-view-manager__header" }
const _hoisted_3 = { class: "ttn-view-manager__toggle" }
const _hoisted_4 = {
  key: 0,
  class: "ttn-view-manager__slot"
}
const _hoisted_5 = {
  key: 1,
  class: "ttn-view-manager__slot"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_pie = _resolveComponent("icon-pie")!
  const _component_icon_path = _resolveComponent("icon-path")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["toggle__option", { 'option--active': _ctx.value && _ctx.value === 'sector' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeView('sector')))
        }, [
          _createVNode(_component_icon_pie),
          _createTextVNode(" Сектор ")
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["toggle__option", { 'option--active': _ctx.value && _ctx.value === 'direction' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeView('direction')))
        }, [
          _createVNode(_component_icon_path),
          _createTextVNode(" Направление ")
        ], 2)
      ])
    ]),
    (_ctx.value && _ctx.value === 'sector')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "sector", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.value && _ctx.value === 'direction')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "direction", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}